import StarIcon from "assets/icons/star-fill.svg";
import styled, { css } from "styled-components";
import { md } from "styles/breakpoint";
import { theme } from "styles/theme";

const StyledHeaderMobileIsVerified = styled.div`
  & .header__mobile-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-gap: 10px;
    height: 68px;
    width: 100%;
    background-color: #333;
    padding: 0 5px;
    .header {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &.--right {
        padding: 3px 0;
        .header__profile {
          &-deposit {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 20px;
          }
          &-level {
            margin-right: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            text-decoration: none;
            cursor: pointer;
            .username {
              display: block;
              max-width: 100px;
              line-height: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              transition: color 0.2s ease-out 0s;
              text-decoration: none;
              color: white;
              font-size: 14px;
            }
            .inner {
              height: 22px;
              display: flex;
              align-items: center;
              .profile-loyalty-level {
                flex-shrink: 0;
                height: 18px;
                width: 18px;
                text-align: center;
                font-size: 10px;
                line-height: 19px;
                font-weight: 700;
                color: rgb(0, 0, 0);
                white-space: nowrap;
                overflow: hidden;
                background-image: url(${StarIcon});
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
                margin-right: 5px;
              }
              .profile-loyalty-bar {
                width: 80px;

                .ant-progress {
                  &-text {
                    display: none;
                  }
                  &-line {
                    margin-bottom: unset;
                  }
                  &-outer {
                    height: 8px !important;

                    margin-inline-end: unset !important;
                    padding-inline-end: unset !important;
                  }
                  &-inner {
                    background-color: rgb(202, 202, 206);
                    height: 100%;
                  }
                  &-bg {
                    height: 100% !important;
                    background: linear-gradient(
                      180deg,
                      #dd3023 0%,
                      #90241e 100%
                    );
                  }
                }
              }
            }
            .achievement {
              font-size: 12px;
              margin: 0px;
              text-decoration: none;
              color: white;
            }
          }
        }
        .header__login {
          text-decoration: none;
          color: white;
          transition: all 0.4s ease 0s;
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              padding-right: 8px;
            }
          }
        }
      }
      a &.--left-authentication {
        padding: 5px 0;
      }
      &__profile {
        display: flex;
        height: 100%;
        &-info {
          display: flex;
          .avt {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 15px;
            padding-right: 20px;
            text-decoration: none;
            justify-content: center;
            .link-user {
              font-size: 12px;
              color: ${theme.colors.secondary[900]};
              text-transform: uppercase;
              font-weight: 500;
              text-decoration: none;
            }
            .avatar-user {
              position: relative;
              display: block;
              width: 38px;
              height: 38px;
              background-color: ${theme.colors.secondary[50]};
              border-radius: 50%;
              border: 2px solid #7e3b32;
              img {
                width: 100%;
                height: 100%;
                border-radius: 100%;
                object-fit: contain;
              }
            }
            .level-user {
              display: none;
              line-height: 40px;
              font-size: 20px;
              width: 38px;
              height: 38px;
              flex-shrink: 0;
              text-align: center;
              font-size: 12px;
              line-height: 40px;
              font-weight: 700;
              color: #000;
              white-space: nowrap;
              overflow: hidden;
              background-image: url(${StarIcon});
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
            }
          }
          .bag {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: flex-start;
            .mess {
              .name {
                font-weight: 700;
                font-size: 14px;
                line-height: 12px;
                color: rgb(248, 160, 26);
                text-transform: uppercase;
                margin-right: 8px;
              }
              .status {
                font-size: 10px;
                font-weight: 700;
                color: rgb(51, 51, 51);
                a {
                  text-decoration: none;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  height: 16px;
                  min-width: 16px;
                  background-color: rgb(253, 228, 16);
                  border-radius: 8px;
                  padding-left: 5px;
                  padding-right: 5px;
                  .user-info__messages-title {
                    position: relative;
                    overflow: hidden;
                    background: rgb(237, 101, 101);
                    border-radius: 8px;
                    height: 16px;
                    line-height: 16px;
                    padding: 0px 4px;
                    font-size: 10px;
                    color: rgb(255, 255, 255);
                    font-weight: 700;
                    margin-left: 3px;
                    margin-right: -5px;
                    display: none;
                    &.empty {
                      background: ${theme.colors.secondary[900]};
                      display: block;
                    }
                  }
                }
              }
            }
            .flex {
              align-items: center;
              display: flex;
            }
            .balance {
              color: white;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .name {
                font-size: 12px;
                margin-right: 5px;
                white-space: nowrap;
              }
              .coin {
                font-size: 12px;
                line-height: 20px;
                font-weight: 700;
                color: rgb(253, 228, 16);
                text-align: right;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  ${md(css`
    .header__mobile-top {
      .header__login {
        .item {
          cursor: pointer;
          img {
            padding-left: 10px;
          }
        }
      }
    }
  `)}
`;
export default StyledHeaderMobileIsVerified;
